// import * as types from '../constants/ActionTypes'

export function home(state = {}, action) {
  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/home.js